/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch } from "react";
import { createCtx } from "~/tools";
import { ResourceDetailsActionDetailsSidebarState } from "../../../types/ResourceDetailsActionDetailsSidebarState";

type ProviderProps = {
  actionDetailsState: ResourceDetailsActionDetailsSidebarState;
  updateActionDetailsState: Dispatch<
    Partial<ResourceDetailsActionDetailsSidebarState>
  >;
};

export const [
  useResourceDetailsActionDetailsState,
  ResourceDetailsActionDetailsSidebarCtxProvider,
] = createCtx<ProviderProps>();
